// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import bemify from 'bemify-js';

import AppNavAccountSwitcherDropdownContainer from 'app/common/components/AppNavAccountSwitcherDropdownContainer';
import PageSection from 'app/common/components/PageSection';
import Styles from 'app/common/components/AppNav.scss';
import kindQuery from 'app/common/components/kindQuery';
import purifyWithDeepCheck from 'app/perf-utils/components/purifyWithDeepCheck';
import Navbar, { NavbarShape } from 'app/common/components/Navbar';

const bem = bemify('app-nav');

const horzKindQuery = {
  [Styles.mediaQueryColumn]: 'padded-horz',
};

const AppNavPageSection = kindQuery(PageSection);

const NavbarPageSection = ({ children, className }) => (
  <PageSection className={className} kind="padded-horz">
    {children}
  </PageSection>
);

const AppNav = props => {
  const accountSwitcherDropdown = !props.canSwitchAccounts ? null : (
    <AppNavAccountSwitcherDropdownContainer />
  );
  // Prevent doubling up padding with `NavbarPageSection` if
  // `AppNavAccountSwitcherDropdown` won't render.
  const appNavPageSectionKindQueries = !accountSwitcherDropdown
    ? null
    : horzKindQuery;
  return (
    <div>
      <div className={bem()}>
        <AppNavPageSection
          className={bem('__page-section')}
          kindQueries={appNavPageSectionKindQueries}
        >
          {accountSwitcherDropdown}
          <Navbar
            {...props}
            className={bem('__navbar')}
            Wrapper={NavbarPageSection}
          />
        </AppNavPageSection>
      </div>
    </div>
  );
};

AppNav.propTypes = {
  ..._.omit(NavbarShape, 'Wrapper'),
  canSwitchAccounts: PropTypes.bool.isRequired,
};

const enhanceAppNav = purifyWithDeepCheck;

export default enhanceAppNav(AppNav);
